import React from 'react';
import uuidv1 from 'uuid/v1';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn';

const AccountsArea = (props) => {
  const { accountList, t, colors, handleLogin } = props;
  return (
    <div className="account-list-body">
      <Scrollbars>
        {accountList &&
          accountList.map((item, index) => {
            const uniqueId = uuidv1();
            return (
              <div className="settings-list__item" key={uniqueId}>
                <div className="letter-wrapper">
                  <span
                    className="letter"
                    style={{
                      textTransform: 'uppercase',
                      backgroundColor: colors[index],
                    }}
                  >
                    {item.value ? item.value[0] : 'M'}
                  </span>
                </div>
                <span className="account-name">{item.value} - {item.key}</span>
                <span className="input">
                  <button type="button" className="btn btn-link btn-switch" onClick={(e) => handleLogin(e, index)}>
                    <FontAwesomeIcon icon={faSignIn} className="mr-2" />
                    {t('loginName')}
                  </button>
                </span>
              </div>
            );
          })}
      </Scrollbars>
    </div>
  );
};

export default AccountsArea;
